var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MyTooltip',{attrs:{"title":_vm.$tc_my('flight_time.value', _vm.timeSeconds)}},[_c('span',[_vm._v("\n\t\t"+_vm._s(_vm.hoursDisplay)+"\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }